module.exports = __webpack_public_path__ + "img/hotelFamily-3.c889ba94.jpg";